import { Component } from 'react';

import { LocalStorage } from 'core/decorators';

import { TopicContentMaxWidth } from 'core/components/Wrappers';

import TopicsList from '../TopicsList';
import SingleTopic from '../SingleTopic';

import { storeOfflineEvent, CLICK_TOPIC } from '../handlers';


class Topics extends Component {
  state = {
    pickedTopicIndex: null,
    topics: [],
  };

  componentDidMount() {
    const lastTopics = JSON.parse(LocalStorage.getItem('lastTopics')) || {};
    this.setState({ topics: lastTopics && lastTopics.data });
  }

  pickTopic = e => {
    const el = e.target.closest('[data-idx]');

    const { idx } = el.dataset;

    this.setState({ pickedTopicIndex: +idx });

    document.body.scrollIntoView();

    storeOfflineEvent(CLICK_TOPIC, { position: idx });
  };

  backToList = () => {
    this.setState({ pickedTopicIndex: null });

    document.body.scrollIntoView();
  };

  render() {
    const { topics } = this.state;
    const { pickedTopicIndex } = this.state;

    return (
      <TopicContentMaxWidth>
        <TopicsList
          pickedTopicIndex={pickedTopicIndex}
          topics={topics}
          pickTopic={this.pickTopic}
        />
        <SingleTopic
          pickedTopicIndex={pickedTopicIndex}
          topics={topics}
          backToList={this.backToList}
        />
      </TopicContentMaxWidth>
    );
  }
}

export { Topics as StorybookComponent };
export default Topics;
